import React from 'react';

interface HourglassTopProps {
  className?: string;
}

const HourglassTop = ({ className }: HourglassTopProps) => (
  <svg
    className={className}
    width="30"
    height="50"
    viewBox="0 0 30 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0L0.0250006 15L10 25L0.0250006 35.025L0 50H30V35L20 25L30 15.025V0H0ZM25 36.25V45H5V36.25L15 26.25L25 36.25Z"
      fill="#263D4B"
    />
  </svg>
);

export default HourglassTop;
